import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import SelectCustom from "../select-custom/SelectCustom";
import { Plus, X } from "lucide-react";

type TimeOption = { value: string; label: string };
type DayOption = { value: string; label: string };

type TimeRangeProps = {
    timeOptions: TimeOption[];
    fromTime: string;
    toTime: string;
    onFromTimeChange: (time: string) => void;
    onToTimeChange: (time: string) => void;
    dayOptions: DayOption[];
    day: string;
    onDayChange: (time: string) => void;
    children?: React.ReactNode;
};

const TimeRange: React.FC<TimeRangeProps> = ({ timeOptions, fromTime, toTime, onFromTimeChange, onToTimeChange, dayOptions, day, onDayChange, children }) => {
    return (
        <Row className="mb-4 align-items-center">
            <Col xs={12} md={2}>
                <SelectCustom
                    options={dayOptions}
                    selectedValue={day}
                    onChange={onDayChange}
                    width="6rem"
                />
            </Col>
            <Col xs={12} md={4} className="d-flex align-items-center">
                <SelectCustom
                    options={timeOptions}
                    selectedValue={fromTime}
                    onChange={onFromTimeChange}
                    width="6rem"
                />
                <span className="me-3 ms-3">–</span>
                <SelectCustom
                    options={timeOptions}
                    selectedValue={toTime}
                    onChange={onToTimeChange}
                    width="6rem"
                />
            </Col>
            <Col xs={12} md={6} className="d-flex">
                {children}
            </Col>
        </Row>
    );

};

export default TimeRange;
